import React from "react";
import {
  Box,
  Container,
  Divider,
  Drawer,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { LuChevronLeft } from "react-icons/lu";
import AppbarBase from "../../../../components/common/appbar";
import SelectApiInput from "../../../../components/common/input/SelectApiInput";
import DatetimeInput from "../../../../components/common/input/DateTimeInput";
import { useSelector } from "react-redux";
import { useOrderContext } from "../../OrderPage";
import moment from "moment";
import Note from "./Note";

interface IOrderInfo {
  open: boolean;
  onClose?: () => void;
}

function OrderInfo({ open, onClose }: IOrderInfo) {
  const { currentHd } = useSelector((state: any) => state.order);
  const { handleUpdateCurrentHd } = useOrderContext();

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      sx={{ width: "100vw" }}
      PaperProps={{ sx: { width: "100%" } }}
    >
      <Box sx={{ width: "100%" }}>
        <AppbarBase>
          <Stack
            sx={{ width: "100%", height: "100%" }}
            direction="row"
            alignItems="center"
            spacing="10px"
          >
            <IconButton sx={{ color: "common.white" }} onClick={onClose}>
              <LuChevronLeft size={25} />
            </IconButton>
            <Typography variant="h3" sx={{ color: "common.white" }}>
              Thông Tin Đơn Hàng
            </Typography>
          </Stack>
        </AppbarBase>
        <Box
          sx={{
            height: "calc(100vh - 60px)",
            overflow: "auto",
            backgroundColor: "background.default",
            padding: "5px 0",
          }}
        >
          <Stack sx={{ backgroundColor: "background.paper" }}>
            <Container maxWidth="sm" sx={{ py: 1 }}>
              <SelectApiInput
                direction="column"
                placeholder="Chọn nhân viên"
                apiCode="dmnv"
                searchFields={["ma_nv", "ten_nv"]}
                getOptionLabel={(option) =>
                  option?.ten_nv ? `${option.ten_nv} (${option.ma_nv})` : ""
                }
                checkEqual={(op, val) => op?.ma_nv === val?.ma_nv}
                value={
                  currentHd?.ma_nv
                    ? {
                        ma_nv: currentHd?.ma_nv || "",
                        ten_nv: currentHd?.ten_nv || "",
                      }
                    : null
                }
                onChange={(val) =>
                  handleUpdateCurrentHd({
                    ma_nv: val?.ma_nv || "",
                    ten_nv: val?.ten_nv || "",
                  })
                }
              />
            </Container>
            <Divider />
            <Container maxWidth="sm" sx={{ py: 1 }}>
              <DatetimeInput
                direction="column"
                value={currentHd?.date_created}
                onChange={(val) => {
                  handleUpdateCurrentHd({
                    date_created: moment(val).toISOString(),
                  });
                }}
              />
            </Container>
          </Stack>
          <Box
            sx={{
              marginTop: 2,
              backgroundColor: "common.white",
              height: "auto",
              py: 1,
            }}
          >
            <Container maxWidth="sm">
              <Note />
            </Container>
          </Box>
        </Box>
      </Box>
    </Drawer>
  );
}

export default OrderInfo;
